import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
import { currentLang } from '../../../utils/functions';
import parse from 'html-react-parser';
//import {submitMailchimpForm, setNewsletterData} from '../../../utils/services';
//import {random} from 'lodash';
import W from '../Word';
import jsonp from 'jsonp';
import { useTranslation } from 'react-i18next';

function ProductNewsletter({productId, settings_data, mailchimp_data, animaltype, status}) {
    const [params, setParams] = useState(null);
    const [email, setEmail] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [message, setMessage] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        if(settings_data){
            setParams(settings_data);
        }
    }, [settings_data])
    
    const handleSubmit = e => {
        e.preventDefault();
        if(email){
            setMessageType(null);
            //var formData = {};
            var url = params[currentLang()+".mailchimp_url"];
            //var url = "https://koopeenkoe.us8.list-manage.com/subscribe/post-json?u=b0017f73d2bf8bb566b38c611&id=3599f6d798";
            //const path = `${action}&${values}`;
            url = url.replace('/post?', '/post-json?');
            var formKeyName = encodeURIComponent("group["+params[currentLang()+".mailchimp_group_id"]+"]["+productId+"]");
            //console.log(formKeyName);
            url += "&"+formKeyName+"="+productId;
            //formData[formKeyName] = productId;
            //formData["EMAIL"] = email;
            url += "&EMAIL="+encodeURIComponent(email);
            url += "&subscribe=Houd+mij+op+de+hoogte!";
            //url += "&c=setNewsletterData";
            //url += "&_=1599494591867";
            //console.log(formData);
            //submitMailchimpForm(url);
            jsonp(url, { param: "c" }, (err, data) => {
                if (err) {
                    setMessageType('error');
                } else if (data.result !== 'success') {
                    setMessageType('error');
                } else {
                    setMessageType('success' );
                };
                setMessage(data.msg);
              });
        }

    }

    return (
        <Fragment>
        {params && productId &&
        <div className="newsletter">
            <h4 className="heading"><W>newsletter.status.{status}</W></h4>
            <p><W>newsletter.message</W></p>
            <form method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" novalidate onSubmit={(e)=>{handleSubmit(e)}}>
                
                <div id="mc_embed_signup_scroll">
                    <div className="mc-field-group">
                        <input type="email" value={email} placeholder={t('newsletter.placeholder')} name="EMAIL" className="required email form-control" id="mce-EMAIL" onChange={(e)=>{setEmail(e.target.value)}} />
                        <input type="submit" value={t('newsletter.button')} name="subscribe" id="mc-embedded-subscribe" className="btn" />
                    </div>
                    <div className="mc-field-group input-group" style={{display: "none"}}>
                        <ul>
                            <li>
                                <input type="checkbox" value={productId} name={"group["+params[currentLang()+'.mailchimp_group_id']+"]["+productId+"]"} id={"mce-group["+params[currentLang()+'.mailchimp_group_id']+"]-30-7"} checked />
                                <label>Lam</label>
                            </li>
                        </ul>
                    </div>
                    {messageType && message &&
                    <div className={"message message--"+messageType}>
                        {parse(message)}
                    </div>
                    }
                    <div id="mce-responses" className="clear">
                        <div className="response" id="mce-error-response" style={{display: "none"}}></div>
                        <div className="response" id="mce-success-response" style={{display: "none"}}></div>
                    </div>
                </div>
            </form>
        </div>
        }
        </Fragment>
    )
}

export default flatstore.connect(['settings_data', 'mailchimp_data'])(ProductNewsletter);
